import styled from 'styled-components';
import { Link } from 'gatsby';

export const EventsSlikSlider = styled.div`
  margin-bottom: 0;
  padding: 30px 50px 0;

  @media (max-width: 1199.98px) {
    padding: 0px 30px 0;
  }

  @media (max-width: 992px) {
    padding: 0px 0px 0;
  }

  @media (max-width: 768px) {
    padding: 0px 0px 0;
  }

  .slick-current {
    div[class*='EventSliderCardstyled__EventSliderCard-'] {
      margin-top: 68px;
      margin-bottom: 0;

      @media (max-width: 575.76px) {
        margin-top: 0px;
      }
    }
  }

  .slick-dots {
    padding-top: 70px;

    @media (max-width: 1199.98px) {
      padding-top: 40px;
    }

    @media (max-width: 767.98px) {
      padding-top: 30px;
    }
  }

  .slick-slide {
    transition: 0.5s;
    margin: 0 auto 68px;
    margin-bottom: 0px;
    float: left;
  }

  .slick-prev {
    @media (min-width: 1200px) {
      left: -70px;
      margin-top: -15px;
    }

    @media (max-width: 992px) {
      left: -35px;
    }
  }

  .slick-next {
    @media (min-width: 1200px) {
      right: -70px;
      margin-top: -15px;
    }

    @media (max-width: 992px) {
      right: -35px;
    }
  }

  &[dir='rtl'] {
    .slick-prev {
      @media (min-width: 1200px) {
        left: -70px;
        margin-top: -15px;
      }

      @media (max-width: 992px) {
        left: -35px;
      }
    }

    .slick-next {
      @media (min-width: 1200px) {
        right: -70px;
        margin-top: -15px;
      }

      @media (max-width: 992px) {
        right: -35px;
      }
    }
  }

  &.margin_slider_sv {
    @media (max-width: 991.98px) {
      margin: 0 15px;
    }

    @media (max-width: 575.98px) {
      margin: 0px;
    }
  }
`;

export const EventSliderCard = styled.div`
  margin-right: 5px !important;
  margin-left: 5px !important;
  border: 0;
  margin: 0 auto 68px;
  display: block;
  background-color: #fff;
  padding-top: 50px !important;
  transition: all 0.5s;
  position: relative;
  cursor: pointer;

  @media (max-width: 768px) {
    margin-left: 0px !important;
    margin-right: 0px !important;
  }

  @media (max-width: 575.98px) {
    margin-bottom: 0px;
  }

  &:after {
    content: '';
    position: absolute;
    top: 0;
    width: 102px;
    height: 5px;
    background: #1b7bdd;

    @media (max-width: 567px) {
      width: 50px;
    }
  }

  &[dir='ltr'] {
    &:after {
      left: 10%;
    }
  }

  &[dir='rtl'] {
    &:after {
      right: 10%;
    }
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const EventCardHeader = styled.div`
  letter-spacing: 1.82px;
  line-height: 15px;
  height: 220px;
  width: 80%;
  margin: 0 auto;
  font-size: 10px;
  text-transform: uppercase;
`;

export const Data = styled.div`
  margin-bottom: 1rem;
  display: block;
  text-transform: uppercase;
  font-family: ${({ dir }) => (dir === 'rtl' ? 'GESSTwoDWTCMedium,serif' : '')};
  font-size: ${({ dir }) => (dir === 'rtl' ? '14px' : '')};
  letter-spacing: ${({ dir }) => (dir === 'rtl' ? '0px' : '')};
`;

export const Title = styled.div`
  margin: 1.75rem 0;
  text-transform: none;
  letter-spacing: normal;
  font-size: 4.25vw;
  font-family: ${({ dir }) =>
    dir === 'rtl' ? 'GESSTwoDWTCMedium,serif' : 'LibreBaskervilleRegular,serif'};
  font-weight: 400;
  line-height: 30px;

  @media (min-width: 392px) {
    font-size: 18px;
  }

  @media (min-width: 1200px) {
    font-size: 20px;
  }
`;

export const Type = styled.div`
  font-size: 2.5vw;
  margin: 0;
  color: #000;
  @media (min-width: 392px) {
    font-size: ${({ dir }) => (dir === 'rtl' ? '14px' : '10px')};
    letter-spacing: ${({ dir }) => (dir === 'rtl' ? '0px' : '')};
  }
`;

export const EventImage = styled.div`
  width: 100%;
  height: 214px;
  overflow: hidden;
  position: relative;

  img {
    position: absolute;
    top: 50%;
    left: 50%;
    width: auto;
    height: 100%;
    max-width: none;
    transform: translate(-50%, -50%);
  }
`;

export const EventSliderLink = styled(Link)`
  @media (max-width: 768px) {
    margin-right: 5px;
    margin-left: 5px;
  }
`;
